import * as React from 'react';

const styles = require('@mintdata-wsp/wsp/ui/components/toasts/errorSubMessages/ErrorSubMessageSupport.less');

export class ErrorSubMessageSupport extends React.Component<any, any>
{
    render()
    {
        return (
            <span>
                We couldn't get a hold of the cloud.<br />
                Please contact <a className={styles.link} href="mailto:support@mintdata.com">support@mintdata.com</a>.
            </span>
        );
    }
}
